import { CartFlowController } from "../../CartFlowController";
import { ICartItems } from "../../../../Interfaces/Cart";
import { EbikeFlow } from "../EbikeFlow";
import { Quantity } from "../../../../Components/Form/Quantity";
import { initQuantitySelector } from "../../Helper/Quantity";

export class Guarantee extends EbikeFlow {
    constructor(cartItems: ICartItems) {
        super("configure-guarantee", CartFlowController.EVENTS.CONFIGURE_DONE, cartItems);
    }

    /**
     * obtain tabs from template
     * @private
     */
    protected initTabs(): this {
        super.initTabs();
        this.tabs.dataset.active = "guarantee";
        return this;
    }

    protected addContent(): this {
        super.addContent();
        const quantity = this.cartItems.items[0].quantity;
        this.content.querySelectorAll<Quantity>("x-quantity.guarantee-quantity").forEach((quantitySelector) => {
            initQuantitySelector(quantity, quantitySelector);
        });
        return this;
    }
}
